module.exports = __webpack_public_path__ + "2b14fecb01ff1af11129008a123f4713.svg";